import { FC, InputHTMLAttributes } from 'react';
import { IMaskInput } from 'react-imask';

import { getInputAria } from './Input.helpers';
import { InputBase } from './Input.type';
import { FieldWrapper } from './atoms/FieldWrapper';

type Props = Prettify<
  InputBase<string> &
    Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'ref'> & {
      mask: string;
      onChange: (value: string) => void;
    }
>;

export const InputMasked: FC<Props> = ({
  className,
  inputClassName,
  mask,
  onChange,
  label,
  placeholder,
  labelOutside,
  value,
  ...props
}) => {
  return (
    <FieldWrapper {...props} label={label} className={className} labelOutside={labelOutside}>
      <IMaskInput
        {...props}
        {...getInputAria(props)}
        mask={mask}
        defaultValue={value}
        onAccept={(value: string) => onChange(value)}
        className={inputClassName}
        placeholder={placeholder ?? ' '} // placeholder must to be " " when nullish to avoid ios styling issues
        data-testid={props['data-testid']}
      />
    </FieldWrapper>
  );
};
